// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageson {
  background-color: #2d348e;
  color: white;
  width: 2.5rem;
  text-align: center;
  border-radius: 10px
}

.pagesof {
  background-color: white;
  color: black;
  width: 2.5rem;
  text-align: center;
  border-radius: 10px
}

#form1 {
  display: block;
}

#form2 {
  display: none;
}

#form3 {
  display: none;
}

#form {
  display: block;
}

.card-title {
  font-size: x-large;
  font-family: fantasy;
  font-weight: 100;
}

input[type=range],
.range {
  border-radius: 0.75em;
  overflow: hidden;
  margin-bottom: 1.5em;
}

input[type=range] {
  background-color: burlywood;
  box-shadow:
    0.3em 0.3em 0.4em var(--bs2) inset,
    -0.3em -0.3em 0.4em var(--bs1) inset;
  display: block;
  padding: 0 0.1em;
  width: 100%;
  height: 1.5em;
  appearance: none;
}

input[type=range]:focus {
  outline: transparent;
}

input[type=range]::-webkit-slider-thumb {
  background-color: #255ff4;
  border: 0;
  border-radius: 50%;
  box-shadow:
    -0.3em -0.3em 0.5em #0937aa inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
  cursor: pointer;
  position: relative;
  width: 1.3em;
  height: 1.3em;
  -webkit-transition: all var(--transDur) linear;
  transition: all var(--transDur) linear;
  z-index: 1;
  appearance: none;
}

input[type=range]:focus::-webkit-slider-thumb {
  background-color: #5583f6;
  box-shadow:
    -0.3em -0.3em 0.5em #0b46da inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
}

input[type=range]::-moz-range-thumb {
  background-color: #255ff4;
  border: 0;
  border-radius: 50%;
  box-shadow:
    -0.3em -0.3em 0.5em #0937aa inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
  cursor: pointer;
  position: relative;
  width: 1.3em;
  height: 1.3em;
  transform: translateZ(1px);
  -moz-transition: all var(--transDur) linear;
  transition: all var(--transDur) linear;
  z-index: 1;
  appearance: none;
}

input[type=range]:focus::-moz-range-thumb {
  background-color: #5583f6;
  box-shadow:
    -0.3em -0.3em 0.5em #0b46da inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
}

input[type=range]::-moz-focus-outer {
  border: 0;
}

.headerstyle {
  background-image: url('http://localhost:7777/LoginImages/reciept.png');
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  height: 67vh;
}

.footerstyle {
  background-image: url('http://localhost:7777/LoginImages/footer.png');
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  height: 19vh;
}

.hovereffect {
  transition: transform 0.5s, box-shadow 0.5s;
  border-radius: 10px;
  overflow: hidden;
}

.hovereffect:hover {
  transform: scale(1.1);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.281);
}

.card-img-top {
  border-radius: 10px 10px 0 0;
}

.bidder_register_form {
  display: flex;
  width: 80vw;
  justify-content: space-evenly;
  margin-top: 5px;
  font-weight: bold;
}

.download_reciept_button {
  display: flex;
  justify-content: center
}

.searchTender {
  width: 40vw;
  height: 80%;
}

.register-pop {
  background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8));
}

@media screen and (max-width: 768px) {
  .searchTender {
    width: 80vw;
    height: 80%;
  }
}


.loader {
  height: 100px;
  width: 100px;
  border: 12px solid #e3e3e3;
  border-radius: 50%;
  border-right-color: #e73d26;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  100%{
    transform: rotate(360deg);
  }
}

.charts {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chart-container {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
table, td ,tr{
  border: 1px solid white !important;
  border-left: 1px solid white !important;
  border-right: none !important;
  border-bottom: none !important;
  height: 2rem !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/pages/innercss.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B;;wCAEsC;EACtC,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EAGb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB;;;2BAGyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8CAAsC;EAAtC,sCAAsC;EACtC,UAAU;EAEV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;;;2BAGyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB;;;2BAGyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,2CAAsC;EAAtC,sCAAsC;EACtC,UAAU;EAEV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;;;2BAGyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sEAAsE;EACtE,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qEAAqE;EACrE,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;AACzB","sourcesContent":[".pageson {\r\n  background-color: #2d348e;\r\n  color: white;\r\n  width: 2.5rem;\r\n  text-align: center;\r\n  border-radius: 10px\r\n}\r\n\r\n.pagesof {\r\n  background-color: white;\r\n  color: black;\r\n  width: 2.5rem;\r\n  text-align: center;\r\n  border-radius: 10px\r\n}\r\n\r\n#form1 {\r\n  display: block;\r\n}\r\n\r\n#form2 {\r\n  display: none;\r\n}\r\n\r\n#form3 {\r\n  display: none;\r\n}\r\n\r\n#form {\r\n  display: block;\r\n}\r\n\r\n.card-title {\r\n  font-size: x-large;\r\n  font-family: fantasy;\r\n  font-weight: 100;\r\n}\r\n\r\ninput[type=range],\r\n.range {\r\n  border-radius: 0.75em;\r\n  overflow: hidden;\r\n  margin-bottom: 1.5em;\r\n}\r\n\r\ninput[type=range] {\r\n  background-color: burlywood;\r\n  box-shadow:\r\n    0.3em 0.3em 0.4em var(--bs2) inset,\r\n    -0.3em -0.3em 0.4em var(--bs1) inset;\r\n  display: block;\r\n  padding: 0 0.1em;\r\n  width: 100%;\r\n  height: 1.5em;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\ninput[type=range]:focus {\r\n  outline: transparent;\r\n}\r\n\r\ninput[type=range]::-webkit-slider-thumb {\r\n  background-color: #255ff4;\r\n  border: 0;\r\n  border-radius: 50%;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0937aa inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n  cursor: pointer;\r\n  position: relative;\r\n  width: 1.3em;\r\n  height: 1.3em;\r\n  transition: all var(--transDur) linear;\r\n  z-index: 1;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\ninput[type=range]:focus::-webkit-slider-thumb {\r\n  background-color: #5583f6;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0b46da inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n}\r\n\r\ninput[type=range]::-moz-range-thumb {\r\n  background-color: #255ff4;\r\n  border: 0;\r\n  border-radius: 50%;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0937aa inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n  cursor: pointer;\r\n  position: relative;\r\n  width: 1.3em;\r\n  height: 1.3em;\r\n  transform: translateZ(1px);\r\n  transition: all var(--transDur) linear;\r\n  z-index: 1;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\ninput[type=range]:focus::-moz-range-thumb {\r\n  background-color: #5583f6;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0b46da inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n}\r\n\r\ninput[type=range]::-moz-focus-outer {\r\n  border: 0;\r\n}\r\n\r\n.headerstyle {\r\n  background-image: url('http://localhost:7777/LoginImages/reciept.png');\r\n  width: 100vw;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  height: 67vh;\r\n}\r\n\r\n.footerstyle {\r\n  background-image: url('http://localhost:7777/LoginImages/footer.png');\r\n  width: 100vw;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  height: 19vh;\r\n}\r\n\r\n.hovereffect {\r\n  transition: transform 0.5s, box-shadow 0.5s;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.hovereffect:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\r\n  border: 1px solid rgba(0, 0, 0, 0.281);\r\n}\r\n\r\n.card-img-top {\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n\r\n.bidder_register_form {\r\n  display: flex;\r\n  width: 80vw;\r\n  justify-content: space-evenly;\r\n  margin-top: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n.download_reciept_button {\r\n  display: flex;\r\n  justify-content: center\r\n}\r\n\r\n.searchTender {\r\n  width: 40vw;\r\n  height: 80%;\r\n}\r\n\r\n.register-pop {\r\n  background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8));\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .searchTender {\r\n    width: 80vw;\r\n    height: 80%;\r\n  }\r\n}\r\n\r\n\r\n.loader {\r\n  height: 100px;\r\n  width: 100px;\r\n  border: 12px solid #e3e3e3;\r\n  border-radius: 50%;\r\n  border-right-color: #e73d26;\r\n  animation: spin 1s ease infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  100%{\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.charts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n}\r\n\r\n.chart-container {\r\n  background: #fff;\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\ntable, td ,tr{\r\n  border: 1px solid white !important;\r\n  border-left: 1px solid white !important;\r\n  border-right: none !important;\r\n  border-bottom: none !important;\r\n  height: 2rem !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
